import flatstore from "flatstore";
import React, { useEffect, useState, Fragment } from "react";
import { useLocation } from "react-router-dom";
import { isNil } from "lodash";
import Meta from "../../components/common/Meta";
import LoadModules from "../../components/modules/LoadModules";
import SubscriptionWizard from "./SubscriptionWizard";
import { getSubscriptionEmbedSlug, getSubscriptionPaths } from "../../utils/functions";
import { getStaticPage } from "../../utils/services";

const Subscription = ({ subscription_static_data }) => {
  const [data, setData] = useState(null);
  const [modules, setModules] = useState(null);
  const { pathname } = useLocation();
  const embedSlug = getSubscriptionEmbedSlug(pathname);

  useEffect(() => {
    if (!embedSlug) {
      return;
    }
    if (isNil(subscription_static_data)) {
      getStaticPage(embedSlug, "subscription_static_data");
    }
  }, [subscription_static_data, embedSlug]);

  useEffect(() => {
    if (!embedSlug || isNil(subscription_static_data)) {
      return;
    }
    const slugOk =
      !subscription_static_data.slug ||
      subscription_static_data.slug === embedSlug;
    if (!slugOk) {
      return;
    }
    setData(subscription_static_data);
    if (subscription_static_data.modules !== null) {
      setModules(subscription_static_data.modules);
    }
  }, [subscription_static_data, embedSlug]);

  const normalizedPath = pathname.replace(/\/$/, "") || "/";
  const { base: subscriptionBase } = getSubscriptionPaths();
  const showPageModules =
    subscriptionBase && normalizedPath === subscriptionBase;

  return (
    <Fragment>
      {showPageModules && modules && (
        <LoadModules modules={modules} type="top" />
      )}
      {data && (
        <Meta
          title={data.seo_title ?? data.title}
          description={data.seo_description ?? data.body}
        />
      )}
      <SubscriptionWizard />
      {showPageModules && modules && (
        <LoadModules modules={modules} type="bottom" />
      )}
    </Fragment>
  );
};

export default flatstore.connect(["subscription_static_data"])(Subscription);
